import { Club } from './club';
import { Goal } from './goal';
import { FiscalYear } from './fiscal-year';

export class ClubGoal {
    public ClubGoalId:string;

    public ClubId:string;
    
    public Club:Club;

    public FiscalYearId:number;
    public FiscalYear:FiscalYear;

    public GoalId:string;
   
    public Goal:Goal;

    public Progress:number = null;

    public GoalValue:number = null;

    //TODO: Turn this into a getter once I implement proper deserialization
    public FiscalYearName:string;

    public AllTimeHigh:number;

    public OrgNodeId:string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/club-goal.ts